<template>
<div class="chapter">
<div class="inner_page">
<div class="section">
<div class="header">
<div class="hgroup">
<h3></h3>
<h1>Lady of Fire</h1>
</div>
</div>
<h1 class="title">
	Lady of Fire</h1>
<h2 class="author">
	ANITA MILLS</h2>
<p>
</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chap139527.vue?1ae6e005